import React, { useContext } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';

import { ExternalActionInputOrResult, Type } from 'src/models/Sidekick/SidekickModuleSpec';
import FormContext from 'src/presentation/contexts/FormContext';
import getControlsFactory from '../Components/controls/ControlsFactory';
import JsonTextEditor from './JsonTextEditor';

type ManualInputProps = {
  attr: string;
};

const PrimitiveTypes = [Type.string, Type.number, Type.currency, Type.bool, Type.timestamp];

const ManualInput = ({ attr }: ManualInputProps) => {
  const { workingState } = useContext(FormContext);
  const input = get(workingState, attr) as ExternalActionInputOrResult;

  const typeSpec = input?.typeSpec;

  if (!typeSpec) {
    return null;
  }

  // const inputVal: string | null = input.value != null ? String(input.value) : null;
  // let dtInput: string[] = [];
  // if (input.typeSpec.type === Type.timestamp && input.value != null) {
  //   dtInput = input.value as string[];
  // }

  const type = typeSpec?.type as Type;
  if (!type) {
    return null;
  }

  if (PrimitiveTypes.includes(type)) {
    const inputControl = getControlsFactory(type);

    const renderedInput = inputControl({ attr: `${attr}.value`, typeSpec });

    return <>{renderedInput}</>;
  }

  return (
    <ManualEditorContainer>
      <JsonTextEditor attr={`${attr}.value`} typeSpec={typeSpec} />
    </ManualEditorContainer>
  );
};

const ManualEditorContainer = styled.div`
  padding-top: 10px;
  width: 100%;
`;

export default ManualInput;
